<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { createEventDispatcher } from 'svelte';
  import type { SessionInfo } from '../../types';
  import ScoreBoard from '../ScoreBoard.svelte';
  import OnboardingModal from '../OnboardingModal.svelte';
  import ShareModal from '../ShareModal.svelte';
  import { onMount } from 'svelte';
  import { checkOnboardingStep } from '../../lib/utils/onboardingUtils';
  import { createMatchShareLink } from '../../lib/apiService';
  import { showToast } from '../../lib/toast';

  export let match;
  export let sessionInfo: SessionInfo;

  const dispatch = createEventDispatcher();

  // Reference to the ScoreBoard component
  let scoreBoardComponent;
  let showOnboardingModal = false;
  let showShareModal = false;
  let shareLink = '';
  let isCreatingShareLink = false;
  

  function handleHighlightsChange(event) {
    const { highlights } = event.detail;
    match.highlights = highlights;
    // console.log('dispatch Highlights changed:', highlights);
    dispatch('highlightsChange', { highlights });
  }
    
  // Function to open the highlight modal via the ScoreBoard component
  function openNewHighlight() {
    if (scoreBoardComponent) {
      scoreBoardComponent.openNewHighlight();
    }
  }

      // Check if user needs account settings onboarding
  async function checkAccountSettingsOnboarding() {
    try {
      const hasSeenOnboarding = await checkOnboardingStep('gameassist_highlights');
      if (!hasSeenOnboarding) {
        // Show welcome modal after a short delay for better UX
        setTimeout(() => {
          showOnboardingModal = true;
        }, 500);
      }
    } catch (error) {
      console.error('Error checking account settings onboarding:', error);
    }
  }

  function closeOnboardingModal() {
    showOnboardingModal = false;
  }

  async function handleShareScoreboard() {
    if (isCreatingShareLink || !match?.id) return;

    isCreatingShareLink = true;
    try {
      await createMatchShareLink(match.id, (result, status) => {
        if (status === 200 || status === 201) {
          // Build the full share URL with hash-based routing
          const baseUrl = window.location.origin;
          shareLink = `${baseUrl}/game-assist/#/share/${result.token}`;
          showShareModal = true;
        } else {
          showToast($_('scoreBoard.shareError'), 'error');
        }
      });
    } catch (error) {
      console.error('Error creating share link:', error);
      showToast($_('scoreBoard.shareError'), 'error');
    } finally {
      isCreatingShareLink = false;
    }
  }

  function closeShareModal() {
    showShareModal = false;
    shareLink = '';
  }

  onMount(async () => {
    await checkAccountSettingsOnboarding();
  });
</script>

  <ScoreBoard 
    bind:this={scoreBoardComponent}
    bind:highlights={match.highlights}
    sessionInfo={sessionInfo}
    myClub={sessionInfo.active_team.club}
    myTeamName={sessionInfo.active_team.name}
    opponentClub={match.opponent_club}
    opponentTeamName={match.opponent_team_name}
    bind:teamScore={match.score_team} 
    bind:opponentScore={match.score_opponent} 
    location={match.location}
    on:highlightsChange={handleHighlightsChange}
  />
  

<!-- Sticky footer button for adding highlights -->
<div class="sticky-footer">
  <div class="sticky-footer-buttons">
    <button
      class="sticky-footer-btn secondary"
      on:click={handleShareScoreboard}
      disabled={isCreatingShareLink}
    >
      <ion-icon name="share-outline"></ion-icon>
      {isCreatingShareLink ? $_('scoreBoard.creatingLink') : $_('scoreBoard.shareScoreboard')}
    </button>
    <button
      class="sticky-footer-btn"
      on:click={openNewHighlight}
    >
      <ion-icon name="add-circle"></ion-icon> {$_('scoreBoard.addHighlight')}
    </button>
  </div>
</div>


<!-- Onboarding Modal -->
<OnboardingModal
  isOpen={showOnboardingModal}
  title={$_('onboarding.gameassist_highlights.title')}
  onClose={closeOnboardingModal}
>
  <p>{$_('onboarding.gameassist_highlights.info')}</p>
  <ul class="list-disc list-inside">
    <li>{$_('onboarding.gameassist_highlights.step1')}</li>
    <li>{$_('onboarding.gameassist_highlights.step2')}</li>
    <li>{$_('onboarding.gameassist_highlights.step3')}</li>
  </ul>
</OnboardingModal>

<!-- Share Modal -->
<ShareModal
  isOpen={showShareModal}
  shareLink={shareLink}
  onClose={closeShareModal}
/>

<style>
</style> 